import { render } from "./Sesiones.vue?vue&type=template&id=6bf6be54"
import script from "./Sesiones.vue?vue&type=script&lang=js"
export * from "./Sesiones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__